import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Returns a handleNav(path) function.
 * - If already on that path → scrolls to top instantly.
 * - If on a different path  → navigates there (ScrollToTop handles the scroll).
 */
export default function useScrollToTop() {
  const { pathname } = useLocation();
  const navigate     = useNavigate();

  const handleNav = (path) => {
    if (pathname === path) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate(path);
    }
  };

  return handleNav;
}